import { ReactNode, useMemo, useState } from "react";
import cx from "classnames";
import { TableTabContext, useTableTabContext } from "./Context";
import styles from "./tableTab.module.scss";

type TTableTab = {
  defaultTab: string;
  children: ReactNode;
};

export function Main({ defaultTab, children }: TTableTab) {
  const [tab, setTab] = useState(defaultTab);
  const value = useMemo(() => ({ activeTab: tab, changeTab: (arg: string) => setTab(arg) }), [tab]);

  return (
    <TableTabContext.Provider value={value}>
      <div className={styles.wrapper}>{children}</div>
    </TableTabContext.Provider>
  );
}

type TTabBox = {
  children: ReactNode;
};

export function TabBox({ children }: TTabBox) {
  return <div className={styles.tab_box}>{children}</div>;
}

type TTab = {
  label: string;
  value: string;
  onClick?: () => void;
};

export function Tab({ label, value, onClick }: TTab) {
  const { activeTab, changeTab } = useTableTabContext();

  const handleClick = () => {
    changeTab(value);
    onClick?.();
  };

  return (
    <button type="button" onClick={handleClick} className={cx(styles.tab, { [styles.active]: activeTab === value })}>
      {label}
    </button>
  );
}

type TPanel = {
  value: string;
  children: ReactNode;
};

export function Panel({ value, children }: TPanel) {
  const { activeTab } = useTableTabContext();

  if (activeTab !== value) {
    return null;
  }

  return <div className={styles.pannel}>{children}</div>;
}

const TableTab = Object.assign(Main, {
  TabBox,
  Tab,
  Panel,
});
export default TableTab;
